import { MatDialog } from '@angular/material/dialog';
import { ChangeEmailDialogComponent } from './../../dialogs/change-email-dialog/change-email-dialog.component';
import { AuthService } from 'src/app/services/auth.service';
import { UserType } from './../../models/user.model';
import { PageEvent } from '@angular/material/paginator';
import { ErrorResponse } from 'src/app/models/error.model';
import { UtilsService } from 'src/app/services/utils.service';
import { TenantsService } from './../../services/tenants.service';
import { CustomTableFilter } from './../generics/table-filter/table-filter.component';
import { getTenantName, getTenantPerson, Tenant } from './../../models/tenant.model';
import { PaginatorStatus, DataTableColumn, SortConfiguration } from './../generics/data-table/data-table.component';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-tenants',
    templateUrl: './tenants.component.html',
    styleUrls: ['./tenants.component.scss']
})
export class TenantsComponent implements OnInit {

    @ViewChild('buttonsColumnTemplate', { static: true })
    buttonsColumnTeplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Tipo de persona', prop: 'tipoPersona', sortable: true },
        { name: 'Nombre / Razón social', parseValue: (tenant: Tenant) => getTenantName(tenant) },
        { name: 'E-Mail', prop: 'email', sortable: true, type: 'email' },
        { name: 'DNI / CUIT', parseValue: (tenant: Tenant) => tenant.tipoPersona === 'FISICA' ? tenant.personaFisica.dni : this.utilsService.parseByType(tenant.personaJuridica.cuit, 'cuit') },
        { name: 'Sexo', prop: 'personaFisica.sexo', sortable: true },
        { name: 'Teléfono', parseValue: (tenant: Tenant) => this.utilsService.parseByType(getTenantPerson(tenant).celular, 'phone') },
        { name: '', width: '130px' }
    ];

    sortConfiguration?: SortConfiguration;

    tenants: Tenant[];

    filters: CustomTableFilter[] = [
        { key: 'personaFisica-nombre', description: 'Nombre', type: 'STRING' },
        { key: 'personaFisica-apellido', description: 'Apellido', type: 'STRING' },
        { key: 'personaJuridica-razonSocial', description: 'Razón social', type: 'STRING' },
        { key: 'personaFisica-dni', description: 'DNI', type: 'DIGITS' },
        { key: 'personaJuridica-cuit', description: 'CUIT', type: 'DIGITS' },
        { key: 'email', description: 'Email', type: 'STRING' },
    ];
    filterValues: any = {};

    userType?: UserType;

    constructor(
        private tenantsService: TenantsService,
        private authService: AuthService,
        private dialog: MatDialog,
        private utilsService: UtilsService
    ) {}

    ngOnInit(): void {
        this.columns.find(col => col.name === '').template = this.buttonsColumnTeplate;
        this.getTenants();
        this.userType = this.authService.getUser()?.tipo;
        if (this.userType !== 'AGENTE') {
            this.columns[this.columns.length - 1].width = '70px';
        }
    }

    getTenants() {
        this.tenantsService.getTenants(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, this.sortConfiguration ? [this.sortConfiguration] : [], this.filterValues)
        .subscribe(response => {
            this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
            this.tenants = response.body;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener inquilinos', error.error?.descripcion));
    }

    updateTenants(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getTenants();
    }

    updateSort(event: SortConfiguration) {
        this.sortConfiguration = event;
        this.getTenants();
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getTenants();
    }

    resetUserPassword(tenant: Tenant) {
        const alert = this.utilsService.confirm('¿Está seguro?', 'Se enviará un email al dueño de la cuenta para generar una nueva contraseña, esta acción no se puede deshacer.');
        alert.afterClosed().subscribe(result => {
            if (result) {
                this.authService.requestRecovery(tenant.email, 'INQUILINO').subscribe({
                    next: _ => this.utilsService.alert('Contraseña regenerada correctamente', 'Se ha enviado un email al email registrado con la nueva clave.'),
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al regenerar clave', error.error?.descripcion)
                });
            }
        });
    }

    changeEmail(tenant: Tenant) {
        this.dialog.open(ChangeEmailDialogComponent, { data: { email: tenant.email } })
            .afterClosed().subscribe(result => {
                if (result) {
                    this.getTenants();
                }
            });
    }

}
